import * as Sentry from '@sentry/react';
import { IGNORE_ERRORS } from '@social-garden/utils/ignoreErrors.ts';
import router from '@/utils/router.ts';

export function initSentry() {
  return Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    beforeSend(event) {
      if (import.meta.env.VITE_APP_ENVIRONMENT === 'development') {
        return null;
      }
      return event;
    },
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration(),
      Sentry.graphqlClientIntegration({
        endpoints: [`${import.meta.env.VITE_APP_URL}/graphql`],
      }),
      Sentry.feedbackIntegration({
        autoInject: false,
        colorScheme: 'system',
        showBranding: false,
        showName: false,
        showEmail: false,
      }),
    ],
    tracesSampleRate: 0.25,
    tracePropagationTargets: [import.meta.env.VITE_APP_URL],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: IGNORE_ERRORS,
  });
}
